import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Spin } from 'antd';
import { store } from './store';
import MainLayout from './layouts/MainLayout';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

import SankalpaPage from './pages/SankalpaPage';
import PujaPage from './pages/PujaPage';
import SamagriPage from './pages/SamagriPage';
import GotraPage from './pages/GotraPage';

const GranthaPage = React.lazy(() => import('./pages/GranthaPage'));
const ContributorsPage = React.lazy(() => import('./pages/ContributorsPage'));
const HierarchyPage = React.lazy(() => import('./pages/HierarchyPage'));
const LanguagePage = React.lazy(() => import('./pages/LanguagePage'));
const CountryPage = React.lazy(() => import('./pages/CountryPage'));
const VyakhyanuvadPage = React.lazy(() => import('./pages/VyakhyanuvadPage'));
const UserManagementPage = React.lazy(() => import('./pages/UserManagementPage'));
const PolicyPage = React.lazy(() => import('./pages/PolicyPage'));
const VyakhyanuvadViewerPage = React.lazy(() => import('./pages/VyakhyanuvadViewerPage'));
const GranthaViewerPageNew = React.lazy(() => import('./pages/GranthaViewerPageNew'));
const AnukramanikaPage = React.lazy(() => import('./pages/AnukramanikaPage'));
const BidhiPage = React.lazy(() => import('./pages/BidhiPage'));
const BidhiViewPage = React.lazy(() => import('./pages/BidhiViewPage'));
const KarmakandaPage = React.lazy(() => import('./pages/KarmakandaPage'));
const KarmakandaCategoryPage = React.lazy(() => import('./pages/KarmakandaCategoryPage'));
const KarmakandaViewPage = React.lazy(() => import('./pages/KarmakandaViewPage'));
const YjsTestPage = React.lazy(() => import('./pages/YjsTestPage'));
const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const MyProfilePage = React.lazy(() => import('./pages/MyProfilePage'));
const PujaViewPage = React.lazy(() => import('./pages/PujaViewPage'));
const PujaEditPage = React.lazy(() => import('./pages/PujaEditPage'));
const RelationPage = React.lazy(() => import('./pages/RelationPage'));

function App() {
  return (
    <Provider store={store}>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Suspense
          fallback={
            <div style={{ textAlign: 'center', padding: '50px' }}>
              <Spin size="large" />
            </div>
          }
        >
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <GranthaPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/granthas"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <GranthaPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/contributors"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <ContributorsPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/hierarchy"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <HierarchyPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/hierarchy/:id"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <HierarchyPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/languages"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <LanguagePage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/countries"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CountryPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/vyakhyanuvad"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <VyakhyanuvadPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <UserManagementPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/policies"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <PolicyPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/vyakhyanuvad-viewer"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <VyakhyanuvadViewerPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/vyakhyanuvad-viewer/:granthaId/:vyakhyanuvadId"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <VyakhyanuvadViewerPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/grantha-viewer-new"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <GranthaViewerPageNew />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/grantha-viewer-new/:id"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <GranthaViewerPageNew />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/anukramanika"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <AnukramanikaPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/anukramanika/:id"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <AnukramanikaPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/bidhi"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <BidhiPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/bidhiView/:id"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <BidhiViewPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/karmakanda"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <KarmakandaPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/karmakanda/category/:category"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <KarmakandaCategoryPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/karmakanda/:id"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <KarmakandaViewPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/sankalpa"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <SankalpaPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/puja"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <PujaPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/pujaView"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <PujaViewPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/pujaView/:id"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <PujaViewPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/pujaEdit/:id"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <PujaEditPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/samagri"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <SamagriPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/gotra"
              element={
                <MainLayout>
                  <GotraPage />
                </MainLayout>
              }
            />

            <Route
              path="/relations"
              element={
                <MainLayout>
                  <RelationPage />
                </MainLayout>
              }
            />

            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <MyProfilePage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/yjstest"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <YjsTestPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </Router>
    </Provider>
  );
}

export default App;